import PubSub from "underpub-js";

var FooterStandard = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FooterStandard',
	};

	$.extend(true, this.options, options);

};

FooterStandard.prototype.init = function() {

	var self = this;

};

export default FooterStandard;
